<template>
    <div v-if="invoicesTable.data.length>0" class="container">
        <vue-table-dynamic class="tableModifier" :params="invoicesTable" @row-click="onSelect" ref="table">
        </vue-table-dynamic>
    </div>
    <Loading v-else/>
</template>
<style scoped lang="scss">
    
</style>
<script>
import VueTableDynamic from 'vue-table-dynamic';
import Loading from '@/components/parts/Loading.vue';
export default {
    name: 'Invoices',
    components: { VueTableDynamic, Loading},
    data() {
        return {
            Invoices: [],
            invoicesTable: {
                data: this.$store.state.invoicesTable,
                header: 'row',
                enableSearch: true,
                pagination: true,
                pageSize: 25,
                pageSizes: [],
                sort: [0,1,3],
                maxWidth:2000,
            },
            tablehead: [['Invoice ID','Customer','Creation Date','Note','Status']],
        }
    },
    sockets: {
        allinvoices(data) {
            this.raw_invoices = data;
        },
    },
    methods: {
        onSelect (index, data) {
            if(data[0]!='Invoice ID'){
                this.$router.push('/invoices/'+data[0]);
            }
        },
        differentDays: function(date){
            var date1 = new Date(date); 
            var date2 = new Date(); 
            
            // To calculate the time difference of two dates 
            var Difference_In_Time = date2.getTime() - date1.getTime(); 
            console.log(Difference_In_Time / (1000 * 3600 * 24));
            // To calculate the no. of days between two dates 
            return (Difference_In_Time / (1000 * 3600 * 24));
        },
        getIncoices: function(){
            var vue = this;
            this.$socket.client.emit('getInvoices',null, (error, response) => {
                if(error=='200'){
                    vue.Invoices = response;
                    vue.invoicesTable.data = vue.tablehead.concat(response.map(data => [data.id,data.customer_name,data.creation_day,data.note,data.payment_day]));
                    vue.$store.state.invoicesTable = vue.tablehead.concat(response.map(data => [data.id,data.customer_name,data.creation_day,data.note,data.payment_day]));
                }
            })
        }
    },
    mounted() {
        this.getIncoices();
    },
}
</script>